import type { userUpdateDTOSchema } from '@tempo-io/id-dto';
import type { z } from 'zod';
import { getIdApi } from '../id/getIdApi';

export const getCurrentUserProfile = async () => {
  const api = getIdApi();
  return (await api.profile.v1.$get()).json();
};

export const getPasswordChangeTicket = async () => {
  const api = getIdApi();
  return (await api.profile.v1['change-password-ticket'].$post({ json: { client: 'id' } })).json();
};

export type AvatarFileType =
  | 'image/png'
  | 'image/jpeg'
  | 'image/webp'
  | 'image/avif'
  | 'image/gif'
  | 'image/svg+xml';

export const getProfilePictureUploadUrl = async ({
  type,
  contentLength,
}: {
  type: AvatarFileType;
  contentLength: number;
}) => {
  const api = getIdApi();
  return (
    await api.profile.v1['picture-upload-url'].$post({ json: { type, contentLength } })
  ).json();
};

export const updateUserProfile = async (data: z.input<typeof userUpdateDTOSchema>) => {
  const api = getIdApi();
  return (await api.profile.v1.$patch({ json: data })).json();
};
